<template>
    <div class="reviews">
        <div class="review-carousel">
            <div class="arrow left" @click="prevSlide">
                <icon type="solid" name="faAngleLeft" aria-hidden="true"></icon>
            </div>
            <div :class="[{ 'active': index === currentIndex }, 'carousel-slide']" v-for="(review, index) in randomize(reviews)" :key="review.name" ref="reviewSlide">
                <h2>{{review.name}}</h2>
                <p>{{review.content}}</p>
            </div>
            <div class="arrow right" @click="nextSlide">
                <icon type="solid" name="faAngleRight" aria-hidden="true"></icon>
            </div>
        </div>
    </div>
</template>

<script>import script from './Reviews';
    export default script;</script>

<style lang="less">
    @import "./Reviews.less";
</style>
